import { ICellRendererParams } from 'ag-grid-community';

import { Select } from 'core/components';

const UomSelectCell = ({ value, data, setValue }: ICellRendererParams) => {
  const options = data?.allowedUoms.map((value) => ({ value, label: value }));

  const handleChange = (_, newValue: string | null) => {
    setValue(newValue);
  };

  return <Select defaultValue={value} onChange={handleChange} options={options} />;
};

export default UomSelectCell;
